export default {
  STATUS: {
    NEW: 1,
    PENDING: 2,
    CLOSED: 3,
  },
};
